// ============================================================================
// DỊCH lỗi RPC (chuỗi kỹ thuật Postgres) → câu nói rõ PHẢI LÀM GÌ.
//
// Mọi mutation đều đổ về describeError() rồi toast.error(), nên chuỗi thô kiểu
//   insufficient_bars: thiếu thanh (vật tư 25, màu , dài 50.00 cm): cần 3, có 0
// đập thẳng vào mặt người dùng. Ca thật đã gặp: người dùng đọc câu đó tưởng KHO
// HẾT HÀNG và đi nhập thêm, trong khi kho còn nguyên — chỉ là kế hoạch cắt trên
// màn hình đã cũ (một lệnh sản xuất BTP chạy xen vào lấy mất đúng 3 thanh đó),
// việc cần làm chỉ là bấm "Phân tích" lại.
//
// Nguyên tắc dịch:
//   1. GIỮ NGUYÊN phần chi tiết của Postgres (số lượng, tên vật tư) — đó là
//      bằng chứng để đối chiếu sổ sách; bịa lại hoặc lược đi là mất dấu vết.
//   2. THÊM một câu hành động. Lỗi không nói được việc cần làm thì người dùng sẽ
//      đoán, mà đoán sai ở đây tốn tiền (nhập thừa vật tư).
//   3. Mã lạ (chưa có trong bảng) → trả null để describeError GIỮ chuỗi gốc.
//      KHÔNG nuốt thành câu chung chung: mất luôn manh mối gỡ lỗi.
//
// Đồng bộ với chỗ ném lỗi: supabase/migrations/*.sql (raise exception '<mã>: ...').
// ============================================================================

// <mã>: <phần chi tiết>. Mã Postgres luôn chữ thường + gạch dưới.
const CODE_RE = /^([a-z][a-z0-9_]*):\s*([\s\S]*)$/

type Rule = {
  // Câu mở đầu thay cho mã kỹ thuật.
  title: string
  // Câu hành động đặt sau phần chi tiết. Bỏ trống = không thêm.
  action?: string
}

const RULES: Record<string, Rule> = {
  // Thiếu THANH cắt. Gần như luôn là kế hoạch cũ chứ không phải hết hàng thật:
  // trang Tối ưu cắt và trang Lệnh sản xuất BTP cùng tiêu MỘT kho thanh.
  insufficient_bars: {
    title: 'Tồn thanh đã thay đổi kể từ lúc Phân tích',
    action:
      'Một phiên cắt hoặc lệnh sản xuất bán thành phẩm khác vừa dùng mất số thanh này. Bấm "Phân tích" lại để lập kế hoạch theo tồn mới — chưa có gì bị trừ kho.',
  },
  insufficient_bom: {
    title: 'Không đủ vật tư tiêu hao',
    action: 'Kiểm tra tồn kho hoặc nhập thêm, sau đó bấm "Phân tích" lại.',
  },
  insufficient_btp: {
    title: 'Tồn bán thành phẩm đã thay đổi',
    action: 'Bấm "Phân tích" lại để tính theo tồn mới — chưa có gì bị trừ kho.',
  },
  btp_coverage_stale: { title: 'Phiếu bán thành phẩm đã thay đổi' },
  btp_item_not_found: {
    title: 'Quy cách bán thành phẩm không còn trong danh mục',
    action: 'Bấm "Phân tích" lại.',
  },
  btp_kind_not_issuable: { title: 'Sai cửa xuất bán thành phẩm' },
  btp_lines_required: { title: 'Thiếu dữ liệu bán thành phẩm' },
  bom_material_missing: { title: 'Định mức thiếu vật tư' },
  checklist_not_draft: { title: 'Phiếu không còn ở trạng thái nháp' },
  checklist_not_found: { title: 'Không tìm thấy phiếu' },
  checklist_line_not_found: { title: 'Không tìm thấy dòng phiếu' },
  line_has_issue: { title: 'Dòng phiếu đang có cảnh báo chưa xử lý' },
  invalid_btp_color: { title: 'Màu không hợp lệ' },
  invalid_btp_kind: { title: 'Loại bán thành phẩm không hợp lệ' },
  invalid_payload: { title: 'Dữ liệu gửi lên không hợp lệ' },
  // Phiếu sản xuất thành phẩm làm sẵn (migration 20260923_0001). Bốn mã này
  // đều nói "dữ liệu đã đổi từ lúc mở form" nên câu hành động phải chỉ rõ
  // việc tiếp theo, không thì người dùng ngồi sửa mãi một chỗ.
  prebuilt_plan_not_found: {
    title: 'Phiếu không còn',
    action: 'Quay lại danh sách phiếu và mở lại.',
  },
  prebuilt_plan_cancelled: {
    title: 'Phiếu đã huỷ',
    action: 'Phiếu đã huỷ thì không sửa được — lập phiếu mới nếu vẫn cần làm.',
  },
  prebuilt_line_not_found: {
    title: 'Dòng sản phẩm không còn trong phiếu',
    action: 'Tải lại trang rồi thao tác lại.',
  },
  prebuilt_line_locked: {
    title: 'Dòng đã sản xuất — khoá quy cách',
    action:
      'Chỉ sửa được số lượng. Cần quy cách khác thì huỷ dòng này rồi thêm dòng mới — hàng đã làm vẫn nằm trong kho.',
  },
  prebuilt_line_has_production: {
    title: 'Dòng đã có hàng sản xuất',
    action: 'Dùng nút Huỷ dòng thay vì xoá — xoá là mất dấu số đã làm.',
  },
  forbidden: {
    title: 'Không đủ quyền',
    action: 'Liên hệ quản trị để được cấp quyền.',
  },
  // Giao đơn cho sale ngoài phạm vi quyền `order:assign` (migration
  // 20260922_0006). Tách khỏi `forbidden` vì việc cần làm khác hẳn: đổi lại
  // người phụ trách là lưu được ngay, không phải chờ cấp quyền.
  forbidden_assign: {
    title: 'Không được giao đơn cho nhân sự này',
    action:
      'Chọn lại người phụ trách trong danh sách (chỉ hiện người bạn được giao đơn), hoặc nhờ quản lý cấp quyền "Giao đơn cho sale khác" rộng hơn.',
  },
  // Giao đơn vào tài khoản đã ngưng hoạt động (set_order_assignee kiểm is_active).
  invalid_assignee: {
    title: 'Không giao được cho nhân sự này',
    action: 'Tài khoản đã ngưng hoạt động — chọn người khác đang làm việc.',
  },
  // Xoá phiếu đã gắn thẻ "Đã chuyển tiền" (trigger expense_requests_guard_transfer_tag,
  // migration 20261023_0001): thẻ là dấu vết khoản tiền đã chuyển, không được mất theo phiếu.
  expense_transfer_tagged: {
    title: 'Không xoá được phiếu đã gắn thẻ "Đã chuyển tiền"',
    action: 'Nhờ thủ quỹ gỡ thẻ trước nếu thật sự cần xoá phiếu.',
  },
  not_authenticated: {
    title: 'Phiên đăng nhập đã hết hạn',
    action: 'Đăng nhập lại rồi thử lại.',
  },
  // Hạ COD (migration 20261026_0002). Phần chi tiết của Postgres đã là câu tiếng
  // Việt (mã đề nghị, lý do không đủ điều kiện, COD hiện tại) — giữ nguyên.
  cod_reduction_not_found: {
    title: 'Không tìm thấy đề nghị hạ COD',
    action: 'Tải lại trang — đề nghị có thể đã bị huỷ hoặc bạn không còn quyền xem.',
  },
  cod_reduction_order_not_found: {
    title: 'Không tìm thấy đơn hàng',
    action: 'Kiểm tra lại mã đơn.',
  },
  cod_reduction_order_ineligible: { title: 'Đơn này chưa đề nghị hạ COD được' },
  cod_reduction_open_exists: {
    title: 'Đơn đang có đề nghị hạ COD chưa xong',
    action: 'Mở đề nghị đó để theo dõi, hoặc huỷ nó trước khi tạo đề nghị mới.',
  },
  cod_reduction_amount_invalid: {
    title: 'Số tiền hạ không hợp lệ',
    action: 'COD sau hạ phải nhỏ hơn COD hiện tại và không âm.',
  },
  cod_reduction_reason_invalid: {
    title: 'Lý do hạ COD không còn dùng được',
    action: 'Chọn lại lý do trong danh sách.',
  },
  cod_reduction_note_required: {
    title: 'Thiếu ghi chú cho lý do hạ COD',
    action: 'Ghi rõ lý do rồi gửi lại.',
  },
  cod_reduction_reason_required: { title: 'Thiếu lý do từ chối' },
  cod_reduction_flow_invalid: {
    title: 'Luồng duyệt hạ COD đang cấu hình sai',
    action: 'Nhờ quản trị kiểm tab Hạ COD → Cấu hình luồng.',
  },
  // Bước không ai làm được → chặn ngay lúc gửi thay vì để đề nghị kẹt giữa chừng.
  // Bước "Cấp trên của Sale phụ trách" không tìm được ai (migration 20261026_0002).
  cod_reduction_no_superior: {
    title: 'Chưa gửi được đề nghị — Sale phụ trách chưa có cấp trên',
    action: 'Nhờ quản trị khai "Cấp cha" cho vị trí của sale (Cấu hình → Vị trí) hoặc "Quản lý phòng ban", rồi gửi lại.',
  },
  cod_reduction_flow_no_actor: {
    title: 'Luồng duyệt có bước chưa ai làm được',
    action:
      'Nhờ quản trị tick quyền "Duyệt đề nghị hạ COD" / gán vị trí cho người duyệt, hoặc sửa bước ở Cấu hình luồng.',
  },
  cod_reduction_stale: {
    title: 'Đề nghị vừa được người khác xử lý',
    action: 'Tải lại trang để xem bước hiện tại.',
  },
  cod_reduction_invalid_status: {
    title: 'Đề nghị đã đổi trạng thái',
    action: 'Tải lại trang để xem trạng thái mới.',
  },
  cod_reduction_wrong_action: {
    title: 'Sai thao tác cho bước này',
    action: 'Tải lại trang rồi thao tác lại.',
  },
  // Danh mục loại định mức (migration 20261102_0001).
  dm_type_code_immutable: {
    title: 'Không đổi được mã loại định mức',
    action: 'Chỉ sửa được tên / thứ tự / trạng thái.',
  },
  dm_type_in_use: {
    title: 'Loại định mức đang được dùng',
    action: 'Bỏ tick "Đang dùng" để ngừng thay vì xoá.',
  },
  // Khoán (migration 20261102_0002/0003). Phần chi tiết của Postgres đã là câu tiếng
  // Việt (mã đơn, số bức còn lại, kỳ) — giữ nguyên.
  piecework_order_not_found: { title: 'Không tìm thấy đơn', action: 'Kiểm tra lại mã đơn.' },
  piecework_order_not_enrolled: {
    title: 'Đơn này không tính khoán',
    action: 'Chỉ đơn vào sản xuất (Đẩy file trở đi) sau ngày bật module mới có việc để khai.',
  },
  piecework_order_closed: {
    title: 'Đơn đã hết hạn khai',
    action: 'Nhờ quản lý khai hộ phần việc đã làm.',
  },
  piecework_period_closed: {
    title: 'Kỳ đã chốt — không sửa được nữa',
    action: 'Sai sót của kỳ đã chốt thì nhờ quản lý ghi Điều chỉnh vào tháng đang mở.',
  },
  piecework_task_not_found: {
    title: 'Đơn không có công đoạn này',
    action: 'Tải lại trang — đơn hoặc cấu hình công đoạn vừa thay đổi.',
  },
  piecework_stage_inactive: { title: 'Công đoạn đã ngừng dùng', action: 'Tải lại trang.' },
  piecework_qty_invalid: { title: 'Số bức không hợp lệ' },
  piecework_qty_exceeds: {
    title: 'Vượt số bức cần làm',
    action: 'Người khác vừa khai phần còn lại — tải lại trang để xem; ai khai nhầm việc của bạn thì bấm "Báo sai".',
  },
  piecework_piece_not_found: { title: 'Bức này không còn ở công đoạn này', action: 'Tải lại trang để xem đơn mới nhất.' },
  piecework_task_over: {
    title: 'Loại tranh này đã đủ số bức ở công đoạn này',
    action: 'Có bức đã khai đang chờ quản lý kiểm tra sau khi sửa đơn. Nhờ quản lý xử lý ở mục Cần kiểm tra rồi khai lại.',
  },
  piecework_entry_not_found: {
    title: 'Không thấy dòng khai',
    action: 'Tải lại trang — dòng có thể vừa được xử lý.',
  },
  piecework_entry_not_editable: {
    title: 'Dòng khai đã được quản lý xử lý',
    action: 'Không sửa / xoá được nữa — cần đổi thì nhờ quản lý.',
  },
  piecework_self_action: {
    title: 'Không tự xử lý cho chính mình',
    action: 'Nhờ người quản lý khác duyệt / khai hộ / điều chỉnh cho bạn.',
  },
  piecework_out_of_scope: { title: 'Ngoài phạm vi duyệt của bạn' },
  piecework_worker_invalid: { title: 'Người này không nhận khoán được' },
  piecework_reason_required: { title: 'Thiếu lý do' },
  piecework_dispute_invalid: { title: 'Không báo sai được dòng này' },
  piecework_dispute_exists: { title: 'Bạn đã báo sai dòng này rồi', action: 'Chờ quản lý xử lý.' },
  piecework_dispute_not_found: { title: 'Báo sai không còn chờ xử lý', action: 'Tải lại trang.' },
  piecework_move_invalid: { title: 'Không chuyển số được' },
  piecework_decision_invalid: { title: 'Thiếu quyết định duyệt / từ chối' },
  piecework_period_invalid: { title: 'Kỳ không hợp lệ' },
  piecework_period_not_ended: { title: 'Chưa chốt được kỳ đang chạy', action: 'Chờ hết tháng rồi chốt.' },
  piecework_period_already_closed: { title: 'Kỳ đã chốt rồi' },
  piecework_period_has_pending: {
    title: 'Chưa chốt được kỳ',
    action: 'Duyệt hoặc từ chối hết dòng chờ duyệt của tháng đó trước.',
  },
  piecework_period_has_disputes: {
    title: 'Chưa chốt được kỳ',
    action: 'Xử lý hết báo sai của tháng đó trước.',
  },
  piecework_adjustment_invalid: { title: 'Số tiền điều chỉnh không hợp lệ' },
  piecework_adjustment_not_found: { title: 'Dòng điều chỉnh không còn', action: 'Tải lại trang.' },
  piecework_range_invalid: { title: 'Khoảng ngày không hợp lệ' },
  piecework_bucket_invalid: { title: 'Kiểu gom không hợp lệ' },
  piecework_history_filter_required: { title: 'Chọn đơn hoặc thợ để xem lịch sử' },
  piecework_go_live_running: {
    title: 'Module khoán đang chạy',
    action: 'Bấm Tạm dừng trước rồi mới đặt mốc khác.',
  },
  piecework_go_live_past: {
    title: 'Không đặt được mốc bắt đầu trong quá khứ',
    action: 'Đơn đã vào sản xuất trước đó không được tính lại — chọn từ bây giờ trở đi.',
  },
  piecework_dm_type_not_found: { title: 'Không còn loại định mức này', action: 'Tải lại trang.' },
  piecework_stage_not_found: { title: 'Có công đoạn không còn trong danh mục', action: 'Tải lại trang.' },
  piecework_stage_in_use: {
    title: 'Không xoá được công đoạn đã có người khai',
    action: 'Bỏ tick "Đang dùng" để ngừng thay vì xoá.',
  },
  // Xoá đơn đã có thợ khai (trigger piecework_guard_order_delete): tiền công không được
  // mất theo đơn.
  piecework_order_has_entries: {
    title: 'Không xoá được đơn đã có thợ khai khoán',
    action: 'Hãy huỷ đơn thay vì xoá, hoặc nhờ quản lý từ chối các dòng khai trước.',
  },
}

// Trả câu tiếng Việt, hoặc null nếu không nhận ra mã (caller giữ chuỗi gốc).
export function translateDbError(raw: string): string | null {
  const m = CODE_RE.exec(raw.trim())
  if (!m) return null
  const rule = RULES[m[1]!]
  if (!rule) return null
  const detail = m[2]!.trim()
  return [rule.title, detail ? ` — ${detail}` : '', rule.action ? `. ${rule.action}` : '']
    .join('')
    .trim()
}
